import { Button, styled } from "@mui/material";

const LightGreenButtonStyled = styled(Button)({
    textTransform: "none",
    fontSize: 16,
    padding: "9px 15px",
    border: "1px solid",
    borderRadius: "6px",
    boxShadow: "0px 4px 7px 2px rgba(46, 169, 132, 0.1)",
    lineHeight: "19px",
    fontWeight: "500",
    minWidth: "150px",
    height: "39px",
    color: "#fff",
    backgroundColor: "#3C8B6F",
    borderColor: "#3C8B6F",
    fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
        backgroundColor: "#164B39",
        borderColor: "#164B39",
    },
    "&:active": {
        backgroundColor: "#164B39",
        borderColor: "#164B39",
    },
    "&:focus": {
        // boxShadow: '0 0 0 0.2rem rgba(22,75,57,.5)',
    },
    "&:disabled": {
        backgroundColor: "#EDEDED",
        border: "1px solid #DDDDDD",
        boxShadow: "none",
        color: "#C3C4C7",
    },
});

export default LightGreenButtonStyled;
